// extracted by mini-css-extract-plugin
export var circle = "_g4-1";
export var exitConfirmationModal = "_g4-5";
export var iframe = "_g4-0";
export var offline = "_g4-3";
export var online = "_g4-2";
export var workstationSelectError = "_g4-4";